import _ from 'lodash'

export default ->
	base: (obj, args, context, info) ->
		if obj.measured?
			obj.measured
		else
			obj.planned
